import React, { useState, useEffect, useContext, useCallback } from 'react'
import { PlayerContext } from '../../../../../Context'
import { Box } from '../../../../../Components/Layout'
import { SectionHeading } from '../../../../../Components/Headers'
import { PlayerCardsGroup } from '../../../../../Components/PersonStatsCard'
import { PlayerDataGQL } from '../../../../../Api'
import { AdUnit } from '../../../../../Components/Ads/AdUnit'

export const RegSeasonRoster: React.FC = () => {
  const {
    isRosterLoading,
    roster: players,
    getTeamCaptains,
  } = useContext(PlayerContext)!
  const [roster, setRoster] = useState<PlayerDataGQL[]>([])
  const getCaptains = useCallback(() => {
    return getTeamCaptains()
  }, [players])

  useEffect(() => {
    if (players.length < 0) return
    setRoster(players)
  }, [isRosterLoading, players])

  return (
    <>
      {getCaptains().length > 0 && (
        <Box>
          <SectionHeading headingText="Captains" />
          <PlayerCardsGroup captains={getCaptains()} />
        </Box>
      )}
      {roster.length > 0 && (
        <>
          <Box>
            <SectionHeading headingText="Attack" />
            <PlayerCardsGroup allPlayers={roster} position="A" />
          </Box>
          <AdUnit bannerType="bannerSecond" aria-label="Reg season roster ad second" />
          <Box>
            <SectionHeading headingText="Midfield" />
            <PlayerCardsGroup allPlayers={roster} position="M" />
          </Box>
          <Box>
            <SectionHeading headingText="Defensive Midfield" />
            <PlayerCardsGroup allPlayers={roster} position="SSDM" />
          </Box>
          <Box>
            <SectionHeading headingText="Defense" />
            <PlayerCardsGroup allPlayers={roster} position="D" />
          </Box>
          <Box>
            <SectionHeading headingText="Long stick midfielder" />
            <PlayerCardsGroup allPlayers={roster} position="LSM" />
          </Box>
          <AdUnit bannerType="bannerThird" aria-label="Reg season roster ad third" />
          <Box>
            <SectionHeading headingText="Faceoff" />
            <PlayerCardsGroup allPlayers={roster} position="FO" />
          </Box>
          <Box>
            <SectionHeading headingText="Goalie" />
            <PlayerCardsGroup allPlayers={roster} position="G" />
          </Box>
        </>
      )}
      {roster.length === 0 && (
        <>
          <Box>
            <AdUnit bannerType="bannerSecond" aria-label="Reg season roster ad second" />
          </Box>
          <Box>
            <AdUnit bannerType="bannerThird" aria-label="Reg season roster ad third" />
          </Box>
        </>
      )}
    </>
  )
}
